<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closeOnEscape]="false"
  [draggable]="false"
  [style]="{ width: '1000px', height: '1000px' }"
  (onHide)="onCancel()"
  header="Crop Image"
>
  <div class="cropper-container" *ngIf="loadCropper">
    <!-- Display the ngx-image-cropper for preview only -->
    <image-cropper
      [aspectRatio]="aspectRatio"
      [imageChangedEvent]="file"
      [resizeToHeight]="resizeToHeight"
      [resizeToWidth]="resizeToWidth"
      [format]="extension"
      [hideResizeSquares]="true"
      (imageCropped)="imageCropped($event)"
    ></image-cropper>

    <div class="preview" *ngIf="croppedImageUrl">
      <p>Preview:</p>
      <img [src]="croppedImageUrl" alt="Cropped preview" />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      styleClass="p-button-outlined p-button-rounded"
      (click)="onCancel()"
      (keydown)="$event.preventDefault()"
    ></p-button>

    <p-button
      label="Crop"
      styleClass="p-button-filled p-button-rounded"
      [disabled]="!croppedImage"
      (click)="onSubmit()"
      (keydown)="$event.preventDefault()"
    ></p-button>
  </ng-template>
</p-dialog>
